module.exports = __webpack_public_path__ + "img/p_3.f4308ec8.jpg";